import type { PackItem } from '../api/types';
import { wornSlot } from '../api/itemCatalog';
import { idiomaAtual, numero, t } from '../i18n/idioma';
import { nomeDoItem } from '../i18n/nomes';

export { wornSlot };

/** Peso em stones. A vírgula decimal é do idioma, não do português. */
export function stones(n: number): string {
  const r = Math.round(n * 100) / 100;
  if (Number.isInteger(r)) return numero(r);
  return r.toLocaleString(idiomaAtual(), { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

/** O título do item: nome, a qualidade só quando não é a comum (feita à mão, excepcional) e a durabilidade. */
export function itemHint(item: PackItem): string {
  const bits = [nomeDoItem(item.defId, item.name)];
  if (item.qualidade === 2) bits.push(t('oficina.excepcional'));
  else if (item.qualidade === 1) bits.push(t('mochila.craftado'));
  if (item.dur != null && item.durMax != null) bits.push(`${item.dur}/${item.durMax}`);
  return bits.join(' · ');
}

/** Mochila + cofre: o que dá para gastar (loja, mercado, topo). */
export function carteiraDoPack(pack: {
  gold?: number;
  silver?: number;
  prataBanco?: number;
  ouroBanco?: number;
}): { gold: number; silver: number } {
  return {
    gold: (pack.gold ?? 0) + (pack.ouroBanco ?? 0),
    silver: (pack.silver ?? 0) + (pack.prataBanco ?? 0)
  };
}

/**
 * Abreviação de jogo: 12.500 → 12.5K, 500.000 → 500K, 1.500.000 → 1.5KK.
 */
export function formatGold(n: number): string {
  const v = Math.round(Number(n) || 0);
  const sign = v < 0 ? '-' : '';
  const abs = Math.abs(v);
  if (abs < 1_000) return sign + numero(abs);
  if (abs < 1_000_000) {
    const k = Math.round(abs / 100) / 10;
    if (k >= 1_000) return sign + escala(k / 1_000) + 'KK';
    return sign + escala(k) + 'K';
  }
  const kk = Math.round(abs / 100_000) / 10;
  if (kk >= 1_000) return sign + escala(kk / 1_000) + 'KKK';
  return sign + escala(kk) + 'KK';
}

function escala(valor: number): string {
  return Number.isInteger(valor) ? String(valor) : valor.toFixed(1);
}
